import { SITE_VARIABLES } from '../../../../common/styles/variables';

interface StylesObject {
    seekBarBufferStyle: { [key: string]: any };
}

interface SeekBarBufferStyleObject {
  root: any;
  animation: any;
}

const seekBarBuffer = (currentVideoBufferedTime: number, currentVideoDuration: number): SeekBarBufferStyleObject => ({
  root: {
    width: currentVideoDuration !== 0 ? `${(currentVideoBufferedTime / currentVideoDuration) * 100}%` : 0,
    height: '100%',
    position: 'absolute',
    left: '0',
    backgroundColor: SITE_VARIABLES.COLORS.LIGHT_GRAY_TRANSPARENT,
  },
  animation: {
    transition: 'width 1s linear',
  },
});

export const getSeekBarBufferStyleObject = (currentVideoBufferedTime: number, currentVideoDuration: number): StylesObject => {
  const showAnimation = currentVideoBufferedTime !== 0;
  const seekBarBufferStyleObject = seekBarBuffer(currentVideoBufferedTime, currentVideoDuration);
  return ({
    seekBarBufferStyle: [
      seekBarBufferStyleObject.root,
      showAnimation && seekBarBufferStyleObject.animation,
    ],
  });
};
